import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CpBody02Placeholder } from 'components/atoms/customer-portal/typography';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
  min-height: 600px;

  ${CpBody02Placeholder} {
    text-align: center;
    max-width: 70%;
    margin: 0 auto;
  }
`;

export const CpSpacesEmptyState: React.FC = () => {
  return (
    <Wrapper>
      <CpBody02Placeholder>
        <FormattedMessage id="customer_portal.spaces.empty_state.title" />
      </CpBody02Placeholder>
    </Wrapper>
  );
};
